<template>
	<div class="page-not-found mh-700">
		<v-layout row wrap justify-center>
			<v-flex xs12>
				<h1>Oops! We couldn't find that page.</h1>
				<p>
					We'll keep an eye out for it. For now, perhaps you'd like to
					browse one of the other locations on our site.
				</p>
				<a href="/home">OK</a>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
export default {};
</script>
<style src="../style.css"></style>
